/* eslint-disable react/no-multi-comp */
import React from 'react';

export const CheckIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <circle id="a" cx="12" cy="12" r="12" />
      <path
        id="b"
        d="M4.396 9.443L13.592.247a.843.843 0 0 1 1.191 1.191l-9.645 9.645a.853.853 0 0 1-.056.052.843.843 0 0 1-1.277.1L.247 7.677a.843.843 0 1 1 1.191-1.192l2.958 2.958z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <use fill="#00816B" xlinkHref="#a" />
      <use fill="#FFF" transform="translate(4.5 6)" xlinkHref="#b" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/PlanAhead/Svgs.js